(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec9e7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec9e7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d7rjb", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d11cac84a4afb7$export$2e2bcd8739ae039);
class $98d11cac84a4afb7$var$VideoUtils {
    constructor(){
        // Initialize caches for players
        this.vimeoPlayers = new Map();
        this.youtubePlayers = new Map();
        this.videoMuteStatus = new Map(); // Track muted status per video/iframe
    }
    // Push video interaction to the GTM data layer
    pushVideoEventToDataLayer(eventAction, videoType, videoLabel) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "video_interaction",
            video_action: eventAction,
            video_type: videoType,
            video_label: videoLabel
        });
    //console.log(`Event pushed: ${eventAction}, Type: ${videoType}, Label: ${videoLabel}`);
    }
    // Enable YouTube API if not already enabled
    enableYouTubeAPI(iframe) {
        if (iframe.src.includes("youtube.com") && !iframe.src.includes("enablejsapi=1")) iframe.src += (iframe.src.includes("?") ? "&" : "?") + "enablejsapi=1";
    }
    // Load YouTube API dynamically
    loadYouTubeAPI() {
        return new Promise((resolve)=>{
            if (window.YT && window.YT.Player) resolve(); // API already loaded
            else {
                const script = document.createElement("script");
                script.src = "https://www.youtube.com/iframe_api";
                script.async = true;
                window.onYouTubeIframeAPIReady = ()=>resolve(); // Wait for API to load
                document.head.appendChild(script);
            }
        });
    }
    // Load Vimeo Player API once (PHP also enqueues it; this waits or loads as fallback)
    loadVimeoAPI() {
        if (typeof Vimeo !== "undefined" && Vimeo?.Player) return Promise.resolve();
        if (this._vimeoApiPromise) return this._vimeoApiPromise;
        this._vimeoApiPromise = new Promise((resolve, reject)=>{
            const src = "https://player.vimeo.com/api/player.js";
            const existing = document.querySelector(`script[src*="player.vimeo.com/api/player.js"]`);
            const onReady = ()=>{
                if (typeof Vimeo !== "undefined" && Vimeo?.Player) resolve();
                else reject(new Error("Vimeo Player API failed to initialize"));
            };
            if (existing) {
                if (typeof Vimeo !== "undefined" && Vimeo?.Player) {
                    resolve();
                    return;
                }
                existing.addEventListener("load", onReady, {
                    once: true
                });
                existing.addEventListener("error", reject, {
                    once: true
                });
                return;
            }
            const script = document.createElement("script");
            script.src = src;
            script.async = true;
            script.onload = onReady;
            script.onerror = reject;
            document.head.appendChild(script);
        });
        return this._vimeoApiPromise;
    }
    // Initialize YouTube Player and cache it
    async initializeYouTubePlayer(iframe, eventHandlers) {
        await this.loadYouTubeAPI();
        const youtubePlayer = new YT.Player(iframe, {
            events: {
                onReady: eventHandlers.onReady || (()=>{}),
                onStateChange: eventHandlers.onStateChange || (()=>{})
            }
        });
        this.youtubePlayers.set(iframe, youtubePlayer);
        return youtubePlayer;
    }
    // Setup progress tracking for both Vimeo and YouTube players
    setupProgressTracking(player, type, source) {
        const progressMarkers = {
            25: false,
            50: false,
            75: false,
            99: false
        };
        const trackProgress = (percentage)=>{
            Object.keys(progressMarkers).forEach((marker)=>{
                if (percentage >= marker && !progressMarkers[marker]) {
                    this.pushVideoEventToDataLayer(`progress_${marker}`, type, source);
                    progressMarkers[marker] = true;
                }
            });
        };
        if (type === "Vimeo") player.on("timeupdate", (data)=>{
            const percentage = data.seconds / data.duration * 100;
            trackProgress(percentage);
        });
        else if (type === "YouTube") {
            const interval = setInterval(()=>{
                const percentage = player.getCurrentTime() / player.getDuration() * 100;
                trackProgress(percentage);
                if (percentage >= 99) clearInterval(interval);
            }, 1000);
        }
    }
    // Handle FancyBox close and reset video playback
    setupFancyBoxCloseHandler(iframe, type, playButton = null, callback = null) {
        const player = type === "Vimeo" ? this.getVimeoPlayer(iframe) : this.getYouTubePlayer(iframe);
        jQuery(document).on("afterClose.fb", async ()=>{
            try {
                if (player) type === "Vimeo" ? await player.play() : player.playVideo();
                if (playButton) {
                    playButton.textContent = "Pause";
                    playButton.classList.add("playing");
                }
                if (typeof callback === "function") callback();
            } catch (error) {}
        });
    }
    // Play and control mute for Vimeo Video
    async playAndControlVimeo(iframe, mute = false) {
        try {
            await this.loadVimeoAPI();
        } catch (error) {
            return;
        }
        const player = this.getVimeoPlayer(iframe);
        if (!player) return;
        try {
            await player.ready();
            const isPaused = await player.getPaused();
            await player.setVolume(mute ? 0 : 1);
            if (isPaused) await player.play();
        } catch (error) {}
        this.setupProgressTracking(player, "Vimeo", iframe.src);
    }
    // Play YouTube video
    async playYouTube(iframe, eventHandlers = {}) {
        this.enableYouTubeAPI(iframe);
        const player = await this.initializeYouTubePlayer(iframe, eventHandlers);
        player.playVideo();
        this.setupProgressTracking(player, "YouTube", iframe.src);
    }
    // Pause Vimeo video
    async pauseVimeo(iframe) {
        try {
            await this.loadVimeoAPI();
        } catch (error) {
            return;
        }
        const player = this.getVimeoPlayer(iframe);
        if (!player) return;
        try {
            await player.pause();
        } catch (error) {}
    }
    // Pause YouTube video
    async pauseYouTube(iframe) {
        const player = this.youtubePlayers.get(iframe);
        if (player) try {
            player.pauseVideo();
        } catch (error) {}
    }
    async isVimeoPlaying(iframe, maxAttempts = 10, interval = 200) {
        try {
            await this.loadVimeoAPI();
        } catch (error) {
            return false;
        }
        const player = this.getVimeoPlayer(iframe);
        if (!player) return false;
        try {
            await player.ready(); // Ensure the player is initialized
            let attempts = 0;
            while(attempts < maxAttempts){
                const isPaused = await player.getPaused();
                if (!isPaused) //console.log(`Vimeo video is playing (after ${attempts + 1} attempts): ${iframe.src}`);
                return true; // Video is playing
                attempts++;
                await new Promise((resolve)=>setTimeout(resolve, interval)); // Wait before retrying
            }
            //console.log(`Vimeo video is not playing after ${maxAttempts} attempts: ${iframe.src}`);
            return false; // Default to not playing if state doesn't stabilize
        } catch (error) {
            return false;
        }
    }
    // Check if YouTube video is playing
    async isYouTubePlaying(iframe) {
        const player = this.youtubePlayers.get(iframe);
        if (player) {
            const state = player.getPlayerState();
            return state === YT.PlayerState.PLAYING;
        }
        return false;
    }
    // Get or create Vimeo player
    getVimeoPlayer(iframe) {
        if (typeof Vimeo === "undefined" || !Vimeo?.Player) return null;
        if (!this.vimeoPlayers.has(iframe)) try {
            const player = new Vimeo.Player(iframe);
            this.vimeoPlayers.set(iframe, player);
        } catch (e) {
            return null;
        }
        return this.vimeoPlayers.get(iframe);
    }
    discardVimeoPlayer(iframe) {
        const player = this.vimeoPlayers.get(iframe);
        this.vimeoPlayers.delete(iframe);
        if (player && typeof player.destroy === "function") player.destroy().catch(()=>{});
    }
    // Get or create YouTube player
    getYouTubePlayer(iframe) {
        return this.youtubePlayers.get(iframe);
    }
}
const $98d11cac84a4afb7$var$videoUtils = new $98d11cac84a4afb7$var$VideoUtils();
var $98d11cac84a4afb7$export$2e2bcd8739ae039 = $98d11cac84a4afb7$var$videoUtils;

});


var $d7rjb = parcelRequire("d7rjb");
const $5d17f9a1539525f1$var$blockVideo = ()=>{
    const videoBlocks = document.querySelectorAll(".block-video");
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const block = entry.target;
                $5d17f9a1539525f1$var$initializeVideoBlock(block);
                observer.unobserve(block); // Unobserve after initialization
            }
        });
    });
    videoBlocks.forEach((block)=>observer.observe(block));
};
// Initialize a single video block
const $5d17f9a1539525f1$var$initializeVideoBlock = (block)=>{
    const playButton = block.querySelector(".play-button");
    const videoWrapper = block.querySelector(".video-wrapper");
    const video = videoWrapper.querySelector("video");
    const iframe = videoWrapper.querySelector("iframe");
    const caption = block.querySelector("figcaption");
    const overlay = block.querySelector(".overlay");
    // Set lazy loading for iframe
    if (iframe) iframe.setAttribute("loading", "lazy");
    // Set a fixed aspect ratio to prevent layout shifts
    videoWrapper.style.aspectRatio = "16/9";
    // Play Video Handler
    const playVideo = async ()=>{
        playButton.classList.add("active");
        caption.classList.add("active");
        overlay.classList.remove("visible");
        if (video) $5d17f9a1539525f1$var$playHTML5Video(video);
        else if (iframe) {
            iframe.classList.add("visible");
            if (iframe.src.includes("vimeo.com")) await (0, $d7rjb.default).playAndControlVimeo(iframe);
            else if (iframe.src.includes("youtube.com")) await (0, $d7rjb.default).playYouTube(iframe, {
                onStateChange: (event)=>$5d17f9a1539525f1$var$handleYouTubeStateChange(event, overlay)
            });
        }
    };
    // Attach event listeners
    playButton.addEventListener("click", playVideo);
    overlay.addEventListener("click", playVideo);
    // Setup events for HTML5 video
    if (video) $5d17f9a1539525f1$var$setupHTML5VideoEvents(video, overlay);
};
// Play HTML5 Video
const $5d17f9a1539525f1$var$playHTML5Video = (video)=>{
    video.setAttribute("controls", "controls");
    video.classList.add("is-playing");
    video.classList.add("visible");
    video.play();
    (0, $d7rjb.default).pushVideoEventToDataLayer("play", "HTML5", video.currentSrc);
};
// Handle YouTube Player State Changes
const $5d17f9a1539525f1$var$handleYouTubeStateChange = (event, overlay)=>{
    const iframeSrc = event.target.getIframe().src;
    switch(event.data){
        case YT.PlayerState.PAUSED:
            (0, $d7rjb.default).pushVideoEventToDataLayer("pause", "YouTube", iframeSrc);
            break;
        case YT.PlayerState.ENDED:
            (0, $d7rjb.default).pushVideoEventToDataLayer("end", "YouTube", iframeSrc);
            overlay.classList.add("visible");
            break;
    }
};
// Setup HTML5 Video Event Listeners
const $5d17f9a1539525f1$var$setupHTML5VideoEvents = (video, overlay)=>{
    video.addEventListener("play", ()=>{
        (0, $d7rjb.default).pushVideoEventToDataLayer("play", "HTML5", video.currentSrc);
    });
    video.addEventListener("pause", ()=>{
        (0, $d7rjb.default).pushVideoEventToDataLayer("pause", "HTML5", video.currentSrc);
    });
    video.addEventListener("ended", ()=>{
        (0, $d7rjb.default).pushVideoEventToDataLayer("end", "HTML5", video.currentSrc);
        overlay.classList.add("visible");
    });
    video.addEventListener("volumechange", ()=>{
        const isMuted = video.muted; // Check if the video is muted
        const eventAction = isMuted ? "mute" : "unmute";
        // Push the event to the GTM data layer
        (0, $d7rjb.default).pushVideoEventToDataLayer(eventAction, "HTML5", video.currentSrc);
    });
    (0, $d7rjb.default).setupProgressTracking({
        type: "HTML5",
        element: video,
        source: video.currentSrc
    });
};
// Preload the first HTML5 video only (never iframe/Vimeo/YouTube – triggers CWV warnings).
const $5d17f9a1539525f1$var$preloadFirstVideo = ()=>{
    const video = document.querySelector(".block-video:first-of-type video");
    if (!video || !video.src) return;
    const preloadLink = document.createElement("link");
    preloadLink.rel = "preload";
    preloadLink.as = "video";
    preloadLink.href = video.src;
    document.head.appendChild(preloadLink);
};
// Initialize blockVideo on DOMContentLoaded
document.addEventListener("DOMContentLoaded", ()=>{
    $5d17f9a1539525f1$var$preloadFirstVideo();
    $5d17f9a1539525f1$var$blockVideo();
});

})();
//# sourceMappingURL=video.js.map
